import { Component } from '@angular/core';
import { UsersComponent } from './users/users.component';
import { RolesComponent } from './roles/roles.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { NgToastService } from 'ng-angular-popup';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '@/app/services/shared/api.service';
@Component({
  selector: 'app-user-role-management',
  standalone: true,
  imports: [
    UsersComponent,
    RolesComponent,
    PermissionsComponent,
    FormsModule,
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
  ],
  templateUrl: './user-role-management.component.html',
  styleUrls: ['./user-role-management.component.css'],
})
export class UserRoleManagementComponent {
  isProjectEdit = false;
  isProjectOpen = false;
  isDialogOpen: boolean = false;
  selectedTab = 'users';
  constructor(
    private toast: NgToastService,
    private getProjectIdService: GetProjectIdService,
    private dialog: MatDialog,
    private apiService: ApiService
  ) {}

  handleDialog() {
    this.isProjectEdit = false;
    this.isProjectOpen = false;
    this.dialog.closeAll();
  }
  openDialog() {
    this.isDialogOpen = !this.isDialogOpen;
  }

  selectTab(item: string): void {
    this.selectedTab = item;
  }
}
